(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qab-announcement')) {
    class QabAnnouncement extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-qab-slide]'));
        this.prevBtn = this.querySelector('[data-qab-prev]');
        this.nextBtn = this.querySelector('[data-qab-next]');
        this.index = 0;
        this.timer = null;
        this.hovering = false;
        this.focused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
        this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';

        if (!this.slides.length) return;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => { this.hovering = true; this.stop(); });
          this.addEventListener('mouseleave', () => { this.hovering = false; this.restart(); });
        }
        this.addEventListener('focusin', () => { this.focused = true; this.stop(); });
        this.addEventListener('focusout', () => { this.focused = false; this.restart(); });

        this.onVisibility = () => (document.hidden ? this.stop() : this.restart());
        document.addEventListener('visibilitychange', this.onVisibility);

        // Theme editor: select block -> show that slide
        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.editorPaused = true; this.stop(); this.go(i); }
        };
        this.onBlockDeselect = () => { this.editorPaused = false; this.restart(); };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.go(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((slide, k) => {
          const active = k === this.index;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-before', k < this.index);
          slide.classList.toggle('is-after', k > this.index);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;
        });
      }

      start() {
        if (!this.autoplay || this.slides.length < 2 || this.timer || this.editorPaused) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        if (!this.hovering && !this.focused && !document.hidden) this.start();
      }
    }
    customElements.define('qab-announcement', QabAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
